import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import {
  FaFolder,
  FaFile,
  FaArrowLeft,
  FaHome,
  FaEllipsisV,
  FaListUl,
  FaEye,
  FaEyeSlash,
  FaTimes,
} from "react-icons/fa";
import { FaRegFileImage } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import awsService from "../services/awsService";
import shareService from "../services/shareService";
import axios from "axios";
import { IoGridOutline } from "react-icons/io5";
import { useStateContext } from "../contexts/ContextProvider";
import { CiFileOn } from "react-icons/ci";
import "./viewfile.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdCopyAll, MdDownload } from "react-icons/md";
import Loading from "../components/Loading";
import FileViewer from "../components/FileViewer";
import Box from "@mui/material/Box";
const ViewVideoFile = () => {
  const { currentColor, currentMode } = useStateContext();
  const [uploading, setupLoading] = useState(false);
  const [downloading, setdownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [files, setFiles] = useState([]);
  const [sharedData, setsharedData] = useState({});
  const [currentPrefix, setCurrentPrefix] = useState("");
  const [previousPrefix, setPreviousPrefix] = useState("");
  const [writeAccess, setWriteAccess] = useState(false);
  const [downloadAccess, setDownloadAccess] = useState(false);
  const [viewOnly, setviewOnly] = useState(false);
  const [showShareModal, setShowShareModal] = useState(true);
  const [sharePassword, setSharePassword] = useState("");
  const [userPrefix, setUserPrefix] = useState("");
  const [viewType, setViewType] = useState("grid");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [Filename, setFilename] = useState("");
  const [parentPrefix, setParentPrefix] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [fileType, setFileType] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [showCopyReplaceModal, setShowCopyReplaceModal] = useState(false);
  const [copyFilename, setcopyFilename] = useState("");
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const params = useParams();

  const updateProgress = (percentage) => {
    console.log(`Upload Progress: ${percentage}%`);
  };
  const fetchData = async (prefix) => {
    try {
      console.log(prefix);
      setLoading(true);
      const response = await awsService.getavailablefoldersforuser({
        shareId: sharedData.shareId,
        prefix: prefix,
      });
      let sortedData = response.sort((a, b) => {
        if (a.Type === "folder" && b.Type !== "folder") {
          return -1;
        }
        if (a.Type !== "folder" && b.Type === "folder") {
          return 1;
        }
        return 0;
      });
      sortedData = sortedData.filter((o) => o.Size !== 0);

      setFiles(sortedData);
      setLoading(false);
      setCurrentPrefix(prefix);
    } catch (error) {
      setLoading(false);

      console.error("Error fetching data:", error);
    }
  };

  const handleFolderClick = (folderKey, pf) => {
    setPreviousPrefix(pf);
    fetchData(folderKey);
  };

  const handleFileClick = (fileKey) => {
    // Handle downloading file
  };

  const handleBackClick = () => {
    console.log(
      Filename,
      "--------------",
      userPrefix,
      "----------",
      currentPrefix
    );
    if (
      previousPrefix === null ||
      previousPrefix === "" ||
      previousPrefix === userPrefix
    ) {
      setCurrentPrefix(userPrefix);
      fetchData(userPrefix);
    } else {
      const parts = currentPrefix.split("/");
      const newPrefix = parts.slice(0, -2).join("/");
      fetchData(newPrefix ? newPrefix + "/" : "");
    }
  };

  const handleHomeClick = () => {
    fetchData(userPrefix);
  };

  const handleDownloadLink = async (item) => {
    console.log(item);
    if (item.Type !== "folder") {
      // Form data to send to the server
      const formData = {
        shareId: sharedData.shareId,
        prefix: item.Key || item.Prefix,
      };

      try {
        // setdownloading(true);

        // Fetch the presigned URL for downloading the file
        let url = await awsService.downloadFileUser(formData);
        console.log("URL copied to clipboard:", url);
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url);
        } else {
          // Use the 'out of viewport hidden text area' trick
          const textArea = document.createElement("textarea");
          textArea.value = url;

          // Move textarea out of the viewport so it's not visible
          textArea.style.position = "absolute";
          textArea.style.left = "-999999px";

          document.body.prepend(textArea);
          textArea.select();

          try {
            document.execCommand("copy");
          } catch (error) {
            console.error(error);
          } finally {
            textArea.remove();
          }
        }

        // Display a toast notification
        // toast.success('Download link copied to clipboard!');
        toast.success(
          "Download link copied! This link is valid for the next 7 days.",
          {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      } catch (error) {
        console.error("Error downloading file:", error);
        setdownloading(false);
        setProgress(0);
      }
    }
  };
  const handleDownload = async (item) => {
    console.log(item);
    if (item.Type !== "folder") {
      // Form data to send to the server
      const formData = {
        shareId: sharedData.shareId,
        prefix: item.Key || item.Prefix,
      };

      try {
        setdownloading(true);

        // Fetch the presigned URL for downloading the file
        let url = await awsService.downloadFileUser(formData);

        // Download the file using Axios
        const response = await axios.get(url, {
          responseType: "blob", // This ensures the response is treated as a binary file
          onDownloadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
            updateProgress(percentCompleted); // Update progress here
          },
        });

        if (response.status === 200) {
          console.log("File downloaded successfully");

          // Create a URL for the downloaded file
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );

          // Create a link element to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
          let name = item.Key || item.Prefix;
          if (item.Key) {
            name = item.Key.substring(item.Key.lastIndexOf("-") + 1);
          } else {
            name = item.Prefix.split("/")
              .filter((part) => part !== "")
              .pop();
          }
          link.setAttribute("download", name); // Set the file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // Remove the link element
          setdownloading(false);
          setProgress(0);
        } else {
          console.error(
            "Failed to download file, status code:",
            response.status
          );
          setdownloading(false);
          setProgress(0);
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        setdownloading(false);
        setProgress(0);
      }
    } else if (item.Type == "folder") {
      try {
        setLoading(true);
        const formData = {
          shareId: sharedData.shareId,
          prefix: item.Key || item.Prefix,
        };
        let response = await awsService.downloadFolderuser(formData);
        if (response) {
          const url = window.URL.createObjectURL(response); // response is already a Blob
          const a = document.createElement("a");
          a.href = url;
          a.download = `${item.Prefix}.zip`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          setLoading(false);
          toast.success("file Downloaded!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    getFilename();
  }, []);
  const handleShare = async () => {
    try {
      const response = await shareService.getSingleShare(params.id, {
        password: sharePassword,
      });
      if (response.status == "error") {
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (response) {
        setsharedData(response);
        setWriteAccess(response.uploadAccess);
        setDownloadAccess(response.downloadAccess);
        setviewOnly(response.viewOnlyAccess);
        setLoading(true);
        const prefix = response.fileData.Key || response.fileData.Prefix;
        setUserPrefix(prefix);
        const response2 = await awsService.getavailablefoldersforuser({
          shareId: response.shareId,
        });
        let sortedData = response2.sort((a, b) => {
          if (a.Type === "folder" && b.Type !== "folder") {
            return -1;
          }
          if (a.Type !== "folder" && b.Type === "folder") {
            return 1;
          }
          return 0;
        });
        sortedData = sortedData.filter((o) => o.Size !== 0);
        setFiles(sortedData);
        setCurrentPrefix(prefix);
        setLoading(false);
        setShowShareModal(false);
      } else {
        setShowShareModal(true);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      if (error && error.response && error?.response?.data.status === "error") {
        let errormsg = error.response?.data.message || "Link Expired";
        toast.error(errormsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Internal Server Error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      console.error("Error sharing file:", error);
    }
  };
  const getFilename = async () => {
    try {
      const response = await shareService.getFilename(params.id, {});
      if (!response.success) {
        setLoading(false);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      if (response.success) {
        let file = response.data.filename
          .split("/")
          .filter((part) => part !== "")
          .pop();
        let filename = file.substring(file.lastIndexOf("-") + 1);

        setParentPrefix(response.data.filename);
        setLoading(false);
        if(response.data.noPassword){
          handleShare()
        }else{
          setFilename(filename);
        }
       
       
      } else {
        setLoading(false);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Link Expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error sharing file:", error);
    }
  };
  const toggleGridView = () => {
    setViewType("grid");
  };

  const toggleListView = () => {
    setViewType("list");
  };
  const handleFileUpload = async (e) => {
    console.log("fileupload");
    const file = e.target.files[0];
    setFileContent(file);
    let newName = getFileNameWithoutExtension(file.name);
    setcopyFilename(newName);

    const formData = new FormData();
    formData.append("filename", file.name);
    formData.append("shareId", sharedData.shareId);
    formData.append("prefix", currentPrefix);

    try {
      setupLoading(true);
      let url = await awsService.uploadFileUser(formData);

      if (typeof url === "string") {
        setLoading(false);
        setupLoading(false);
        setShowCopyReplaceModal(true);
      } else {
        const response2 = await axios.put(url.imageData, file, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
            updateProgress(percentCompleted);
          },
        });
        if (response2.status === 200) {
          setupLoading(false);
          setProgress(0);
          console.log("File uploaded successfully");
        } else {
          setupLoading(false);
          setProgress(0);
          console.error(
            "Failed to upload file, status code:",
            response2.status
          );
        }

        fetchData(currentPrefix);
      }
    } catch (error) {
      setupLoading(false);
      setProgress(0);
      console.error("Error uploading file:", error);
    }
  };

  const handlePreviewFile = async (item) => {
    try {
      console.log(item);
      setLoading(true);
      const response = await awsService.UserPreviewVideo({
        Key: item.Key,
        shareId: sharedData.shareId,
      });

      console.log(response);
      // const blob = await response.blob();

      setFileType(item.Key.split(".").pop());
      setLoading(false);

      setFileData(response);

      setShowModal(true);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleContextMenu = (e) => {
    e.preventDefault(); // Prevent right-click menu
  };


  const renderFileContent = () => {
    if (
      fileType === "png" ||
      fileType === "jpg" ||
      fileType === "jpeg" ||
      fileType === "gif" ||
      fileType === "avif"
    ) {
      return <img src={fileData} alt="File content" />;
    }
    if (fileType === "mp4" || fileType === "webm") {
      return   <video
      src={fileData}
      controls
      onContextMenu={handleContextMenu}
      controlsList="nodownload" // This removes the download option in some browsers
    />;
    }
    if (fileType === "mp3" || fileType === "wav") {
      return <audio src={fileData} controls
                onContextMenu={handleContextMenu}
          controlsList="nodownload"  />;
    }

    return <p>Unsupported file type</p>;
  };

  const handleClose = async () => {
    setShowModal(false);
  };

  const handleReplaceUpload = async () => {
    setLoading(true);
    const file = fileContent;
    console.log(file);
    setFileContent(file);
    const newname = getFileNameWithoutExtension(file.name);
    setcopyFilename(newname);
    const formData = new FormData();
    formData.append("filename", file.name);
    formData.append("shareId", sharedData.shareId);
    formData.append("prefix", currentPrefix);
    try {
      let url = await awsService.replaceUserFile(formData);
      const response2 = await axios.put(url.imageData, file, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          updateProgress(percentCompleted);
        },
      });
      if (response2.status === 200) {
        console.log("File uploaded successfully");
        // let url = awsService.updateDBUpload({
        //   prefix: currentPrefix,
        //   awsId,
        //   bucketName,
        // });
        // if (url) {
        //   setLoading(false);
        // }
        setShowModal(false);
        setLoading(true);
        setTimeout(async () => {
          fetchData(currentPrefix);
        }, 3000);

        console.log("dbupdated", "-------------------");
      } else {
        setLoading(false);
        console.error("Failed to upload file, status code:", response2.status);
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };

  const handleCopyUpload = async () => {
    console.log(fileContent);

    const originalFile = fileContent; // Replace fileContent with the actual File object
    // Get the original file name without the extension
    const originalFileName = originalFile.name
      .split(".")
      .slice(0, -1)
      .join(".");
    // Get the file extension
    const fileExtension = originalFile.name.split(".").pop();
    const newName = getFileNameWithoutExtension(copyFilename);
    // Create a timestamp
    const timestamp = Date.now();

    // Create the new file name
    const newFileName = `${newName}.${fileExtension}`;

    // Create a new file with the desired name
    const newFile = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    handleFileUploadCopy(newFile);
  };
  const getFileNameWithoutExtension = (fileName) => {
    const parts = fileName.split(".");
    parts.pop(); // Remove the extension
    return parts.join("."); // Rejoin the remaining parts
  };

  const handleFileUploadCopy = async (e) => {
    console.log(sharedData, "-----");
    setLoading(true);
    const file = e;
    console.log(file);
    setFileContent(file);
    const newname = getFileNameWithoutExtension(file.name);
    setcopyFilename(newname);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("shareId", sharedData.shareId);
    formData.append("prefix", currentPrefix);

    try {
      let url = await awsService.uploadFileUser(formData);
      if (typeof url === "string") {
        setLoading(false);
        setupLoading(false);
        setShowCopyReplaceModal(true);
      } else {
        const response2 = await axios.put(url.imageData, file, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            updateProgress(percentCompleted);
          },
        });
        if (response2.status === 200) {
          console.log("File uploaded successfully");
          // let url = awsService.updateDBUpload({
          //   prefix: currentPrefix,
          //   awsId,
          //   bucketName,
          // });
          // if (url) {
          //   setLoading(false);
          // }
          setShowModal(false);
          setLoading(true);
          setTimeout(async () => {
            fetchData(currentPrefix);
          }, 5000);

          console.log("dbupdated", "-------------------");
        } else {
          setLoading(false);
          console.error(
            "Failed to upload file, status code:",
            response2.status
          );
        }
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };
  return (
    <div className="w-full ">
      {!showShareModal && (
        <img
          src="/doclogo-horizontal.png"
          alt="DocBox Logo"
          className=" h-12 w-48  mt-4 ml-5 "
        />
      )}

      {loading && (
        <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50">
          <div
            className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
            style={{
              borderTopColor: "white",
              borderBottomColor: "white",
            }}
          ></div>
          <p className="mt-4 text-white">Loading...</p>
        </div>
      )}
      <div>
        {" "}
        <style>
          {`
      body {
        background-image: url("/logbg.avif");
        background-size: cover; 
        background-repeat: no-repeat;
        overflow:hidden
        margin: 0;
        padding: 0;
      }
    `}
        </style>
        {!showShareModal ? (
          <Container fluid className="p-4">
            {uploading && (
              <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 text-white">
                <div
                  className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                  style={{
                    borderTopColor: "white",
                    borderBottomColor: "white",
                  }}
                ></div>
                <p className="mt-4">loading... {progress}%</p>
                <div className="progress w-3/4 mt-2">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            )}
            {downloading && (
              <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 text-white">
                <div
                  className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                  style={{
                    borderTopColor: "white",
                    borderBottomColor: "white",
                  }}
                ></div>
                <p className="mt-4">Downloading... {progress}%</p>
                <div className="progress w-3/4 mt-2">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            )}
            <hr className="border-t border-gray-500 my-3" />

            <div className="flex justify-between items-center naving">
              <div className="flex space-x-2">
                {parentPrefix != currentPrefix && (
                  <>
                    <button
                      className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                      onClick={handleBackClick}
                      data-tip="Back"
                    >
                      <FaArrowLeft
                        className="mr-1"
                        style={{ fontSize: "1.3rem" }}
                      />
                    </button>
                    <button
                      className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                      onClick={handleHomeClick}
                      data-tip="Home"
                    >
                      <FaHome className="mr-3" style={{ fontSize: "1.5rem" }} />
                    </button>
                    {/* <h1 className="text-2xl font-bold ml-3  text-gray-500">Doc Box</h1> */}
                  </>
                )}
                <h3
                  class=" text-2xl font-bold  tracking-wide mt-2"
                  style={{
                    color: "#535353",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  {Filename || ""}
                </h3>
              </div>
              <div className="flex space-x-2">
                <div className="flex space-x-2">
                  <button
                    className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                    onClick={toggleListView}
                    title="Toggle List View"
                    data-tip="List View"
                  >
                    <FaListUl className="mr-2" style={{ fontSize: "1.4rem" }} />
                  </button>
                  <button
                    className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                    onClick={toggleGridView}
                    title="Toggle Grid View"
                    data-tip="Grid View"
                  >
                    <IoGridOutline
                      className="mr-2"
                      style={{ fontSize: "1.4rem" }}
                    />
                  </button>
                </div>
                {writeAccess && (
                  <label
                    className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 cursor-pointer"
                    style={{ backgroundColor: currentColor }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                    <input
                      type="file"
                      className="hidden"
                      onChange={(e) => {
                        handleFileUpload(e);
                      }}
                    />
                  </label>
                )}
              </div>
            </div>

            <hr className="border-t border-gray-500 my-4" />

            {viewType === "grid" ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4  gap-4 mx-5 ">
                {files.map((item, index) => (
                  <div className="relative">
                    {item.Type && (
                      <div
                        className="d-flex absolute top-0 right-0 mt-2 mr-6"
                        style={{ zIndex: "5" }}
                      >
                        <span
                          onClick={
                            item.Type === "folder"
                              ? () =>
                                  handleFolderClick(
                                    item.Prefix,
                                    item.ParentFolder
                                  )
                              : () => handlePreviewFile(item)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <>
                            {downloadAccess && (
                              <>
                                {/* {item.Type !== "folder" && (
                                  <MdCopyAll
                                    size={25}
                                    style={{
                                      marginTop: "10px",
                                      marginRight: "10px",
                                    }}
                                  />
                                )} */}
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownload(item);
                                  }}
                                  style={{ cursor: "pointer", zIndex: 10 }}
                                  title="Download File"
                                  data-tip="Grid View"
                                  className="hover-icon"
                                >
                                  <MdDownload
                                    size={25}
                                    style={{
                                      marginTop: "10px",
                                      marginRight: "10px",
                                    }}
                                  />
                                </span>
                              </>
                            )}
                          </>
                        </span>
                      </div>
                    )}
                    <div
                      key={index}
                      className="p-4 rounded-lg shadow-md cursor-pointer relative border-t-4 border-b-4 border-l border-r border-gray-300 bg-white grid-item"
                      style={{ maxWidth: "400px", minHeight: "135px" }}
                      onClick={
                        item.Type === "folder"
                          ? () =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                          : () => handlePreviewFile(item)
                      }
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={30}
                            style={{ color: currentColor }}
                            onClick={() =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                            }
                          />
                          <span className="flex-grow">
                            {item.Prefix.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          </span>
                        </>
                      ) : (
                        <>
                          {["jpg", "png", "avif"].includes(
                            item.Key.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={30}
                              className="mr-3 cursor-pointer"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={30}
                              className="mr-3 cursor-pointer"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )}
                          <span
                            className="flex-grow"
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "200px", // Adjust maxWidth as needed
                              display: "inline-block",
                              cursor: "pointer",
                            }}
                            title={item.Key.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          >
                            {item.Key.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {files.map((item, index) => (
                  <React.Fragment key={index}>
                    <div
                      className={`flex items-center p-2 ${
                        currentMode === "Dark" ? "text-white" : "bg-white"
                      }`}
                      style={{
                        backgroundColor:
                          currentMode === "Dark" ? "#33373E" : "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (item.Type === "folder") {
                          handleFolderClick(item.Prefix, item.ParentFolder);
                        } else if (item.Type === "file") {
                          handlePreviewFile(item);
                        }
                      }}
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={30}
                            className="mr-3 cursor-pointer"
                            style={{ color: currentColor }}
                            onClick={() =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                            }
                          />
                          <span className="flex-grow">
                            {item.Prefix.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          </span>
                        </>
                      ) : (
                        <>
                          {["jpg", "png", "avif"].includes(
                            item.Key.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={30}
                              className="mr-3 cursor-pointer"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={30}
                              className="mr-3 cursor-pointer"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )}
                          <span className="flex-grow">
                            {item.Key.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                            {/* {item.Key.substring(item.Key.lastIndexOf("-") + 1)} */}
                          </span>
                        </>
                      )}
                      {item.Type !== "folder" && (
                        <div className="ml-auto flex items-center">
                          <span
                            onClick={
                              item.Type === "folder"
                                ? () =>
                                    handleFolderClick(
                                      item.Prefix,
                                      item.ParentFolder
                                    )
                                : () => handlePreviewFile(item)
                            }
                            style={{ cursor: "pointer" }}
                            title="Copy Download Link"
                            data-tip="Grid View"
                            className="hover-icon"
                          >
                            {/* <MdCopyAll
                              size={25}
                              style={{ marginRight: "10px" }}
                            /> */}
                          </span>
                          {downloadAccess && (
                          <span
                            onClick={() => handleDownload(item)}
                            style={{ cursor: "pointer" }}
                            title="Download File"
                            data-tip="Grid View"
                            className="hover-icon"
                          >
                            <MdDownload
                              size={25}
                              style={{
                                color: currentMode === "Dark" ? "#fff" : "",
                              }}
                            />
                          </span>
                          )}
                        </div>
                      )}
                    </div>
                    {index !== files.length - 1 && (
                      <div
                        className="mx-2 border-b"
                        style={{
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          backgroundColor:
                            currentMode === "Dark" ? "#33373E" : "white",
                        }}
                      ></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </Container>
        ) : Filename ? (
          <div className="flexbox">
            <div className="flexCenterBox">
              <div className="logoBox">
                <img
                  src="/doclogo-horizontal.png"
                  alt="DocBox Logo"
                  className=" h-12 w-48 "
                />
              </div>
              <div className="card shadow">
                <div className="card-header">
                  <h5 className="card-title text-center p-3">
                    Please Enter Password
                  </h5>
                </div>
                <div className="card-body p-4">
                  <p className="mb-4">
                    You've received a link to a file that requires a password.
                  </p>
                  <div
                    className="filename-container mb-4 text-center"
                    style={{
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      background: "#f8f9fa",
                      padding: "10px",
                    }}
                  >
                    <h4
                      className="filename"
                      style={{
                        fontSize: "1rem",
                      }}
                    >
                      {Filename}
                    </h4>
                  </div>
                  <p className="mb-4">
                    To open the content, enter the password. If you don't have
                    the link password, ask the person who shared the content
                    with you.
                  </p>
                  <div className="input-group mb-4">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      value={sharePassword}
                      onChange={(e) => setSharePassword(e.target.value)}
                    />
                    <span
                      className="input-group-text password-toggle"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleShare}
                    style={{ backgroundColor: "#036bb3" }}
                  >
                    Verify
                  </button>
                </div>
                {/* <div className="card-footer">
              <button className="btn btn-primary w-100" onClick={handleShare}>Verify</button>
            </div> */}
              </div>
            </div>
          </div>
        ) : (
          <Loading loading={"loading"} currentColor={currentColor} />
        )}
        <div>
          <ToastContainer />
        </div>
      </div>

      <Modal
        show={showCopyReplaceModal}
        onHide={() => setShowCopyReplaceModal(false)}
        backdrop="static"
        keyboard={false}
        className="modal-dialog-centered"
      >
        <Modal.Header className="bg-white border-b border-gray-300">
          {/* <div class="p-3 mb-2 bg-warning text-dark">File name already exists. Copy or Replace</div> */}
          <div className="text-xl font-semibold text-gray-600">
            Rename or Replace
          </div>
          <Button
            variant="light"
            onClick={() => setShowCopyReplaceModal(false)}
            className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
          >
            <FaTimes color="gray" />
          </Button>
        </Modal.Header>
        <Modal.Body className="p-6 overflow-auto">
          <Form>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <div className="flex mb-3">
                <div className="flex-1 mr-2">
                  <input
                    type="text"
                    placeholder="Filename"
                    value={copyFilename}
                    onChange={(e) => setcopyFilename(e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
              {/* <div className="flex mb-3">
          <div className="flex-1 mr-2">
            <TextField
              label="Filename"
              value={fileContent.name}
              InputProps={{
                readOnly: false,
              }}
              variant="outlined"
              size="small"
              fullWidth
            />
          </div>
        </div> */}
            </Box>
          </Form>
        </Modal.Body>
        <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
          <Button
            variant="primary"
            onClick={() => {
              // Implement the copy functionality here
              console.log("Copy clicked");
              setShowCopyReplaceModal(false);
              handleCopyUpload();
            }}
            className="mr-2"
          >
            Rename
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              // Implement the replace functionality here
              console.log("Replace clicked");
              setShowCopyReplaceModal(false);
              handleReplaceUpload();
            }}
          >
            Replace
          </Button>
        </Modal.Footer>
      </Modal>

      <FileViewer
        renderFileContent={renderFileContent}
        onClose={handleClose}
        showModal={showModal}
      />
    </div>
  );
};

export default ViewVideoFile;
